import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  Inject,
  inject,
  input,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import {WindowSizeService} from '../../../../services/window-size.service';
import {SearchWidgetV3StateService} from '../../services/search-widget-v3-state.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-search-widget-v3-wrapper',
  templateUrl: './search-widget-v3-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeAnimation', [
      transition(':enter', [style({opacity: 0}), animate('300ms', style({opacity: 1}))]),
      transition(':leave', [animate('100ms', style({opacity: 0}))]),
    ]),
  ],
})
export class SearchWidgetV3WrapperComponent implements OnInit {
  public isInline = input<boolean>();
  public deviceReady = signal(false);
  protected atTop = signal(true);
  protected cssClass = computed<string>(() => {
    return this.atTop() || this.isInline() ? 'relative' : 'fixed top-0 left-0 w-full z-10';
  });
  protected placeholderCssClass = computed<string>(() => {
    return (
      this.cssClass() +
      ' ' +
      (this.isInline() ? 'h-16 min-h-16' : 'h-[117px] min-h-[117px] md:h-16 md:min-h-16 bg-white')
    );
  });
  protected desktopExpandedCssClass = computed<string>(() => {
    return this.isDesktopSuggestionsPanelOpen() ? 'h-[36rem]' : 'h-3/4';
  });
  private readonly defaultHeaderHeight: number = 64;
  private readonly mobileTreshold: number = 768;
  private windowSizeService = inject(WindowSizeService);
  private widgetState = inject(SearchWidgetV3StateService);
  public isSearchWidgetExpanded = this.widgetState.isSearchWidgetExpanded;
  public shouldFocusPlacesField = this.widgetState.shouldFocusPlacesField;
  public isDesktopSuggestionsPanelOpen = this.widgetState.isDesktopSuggestionsPanelOpen;
  private size = this.windowSizeService.windowSize;
  protected isMobile = computed<boolean>(() => this.size() && this.size()[0] < this.mobileTreshold);

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.deviceReady.set(true);
      });
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.atTop.set(window.scrollY <= this.defaultHeaderHeight);
  }

  public closeDesktopExpandedPanel(): void {
    this.widgetState.updateIsSearchWidgetExpanded(false);
  }
}
